import React from 'react';
import './GlowBorder.css';

const DEFAULT_GRADIENT = 'conic-gradient(#7c3aed, #a855f7, #06b6d4, #22d3ee, #a855f7, #7c3aed 80%)';
const DEFAULT_FILL = '#7c3aed';
const DEFAULT_FILL_HOVER = '#8b5cf6';

/**
 * Reusable animated glowing border wrapper.
 * Forwards ref to the root div so it works as the single child of MUI Tooltip.
 *
 * Props:
 *  - size        — width/height in px (default 46)
 *  - borderRadius — border-radius in px (default 6)
 *  - gradient    — conic-gradient string for the rotating border
 *  - fill        — solid background color for the center cutout
 *  - fillHover   — center color on hover
 *  - style       — extra styles on the outer wrapper
 *  - className   — extra class on the outer wrapper
 */
const GlowBorder = React.forwardRef(({
  children,
  size = 46,
  borderRadius = 6,
  gradient = DEFAULT_GRADIENT,
  fill = DEFAULT_FILL,
  fillHover = DEFAULT_FILL_HOVER,
  style,
  className = '',
  ...rest
}, ref) => {
  const sizeStyle = { width: size, height: size };
  const radiusStyle = { borderRadius };

  return (
    <div
      ref={ref}
      className={`glow-border ${className}`}
      style={{ ...sizeStyle, ...style }}
      {...rest}
    >
      <div
        className="glow-border__glow"
        style={{
          ...radiusStyle,
          '--glow-gradient': gradient,
        }}
      />
      <div
        className="glow-border__border"
        style={{
          ...radiusStyle,
          '--glow-gradient': gradient,
          '--glow-fill': fill,
          '--glow-fill-hover': fillHover,
        }}
      />
      <div style={{ position: 'relative', zIndex: 3, width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        {children}
      </div>
    </div>
  );
});

GlowBorder.displayName = 'GlowBorder';

export default GlowBorder;
